import { StoreActionTypeEnum } from '@libs/types';
import { UnknownAction, AsyncThunk } from '@reduxjs/toolkit';

type GenericAsyncThunk = AsyncThunk<unknown, unknown, never>;
type RejectedAction = ReturnType<GenericAsyncThunk['rejected']>;
type PendingAction = ReturnType<GenericAsyncThunk['pending']>;

export function isPendingAction(action: UnknownAction): action is PendingAction {
    return action.type !== 'fetchJsonAsync/pending' && action.type.endsWith('/pending');
}

export function isPendingWidgetAction(action: UnknownAction): action is PendingAction {
    return action.type === 'fetchJsonAsync/pending' || action.type === 'fetchScenario/pending';
}

export function isRejectedAction(action: UnknownAction): action is RejectedAction {
    return action.type.endsWith('/rejected');
}

export function isUpdateWidget(action: UnknownAction): action is RejectedAction {
    return action.type.startsWith(StoreActionTypeEnum.updateWidgetValue);
}
